import { i18nKeys, useTranslation } from 'locales';
import { Button } from 'shared/io';
import { DialogShowId, DialogShowSize, showDialog } from 'store/view/view.actions';
import type { Debtor } from 'types/store/client-state';

import DebtorBatchActions from './DebtorBatchActions';

type ShowCheckBoxProps = {
  listUserChecked: Debtor[];
  selectAll: boolean;
  totalObjects?: number;
  reload?: VoidFunction;
};

export const ShowCheckBox = ({
  listUserChecked,
  selectAll,
  totalObjects,
  reload,
}: ShowCheckBoxProps) => {
  const { t } = useTranslation();

  const openBatchActionsModal = () => {
    showDialog({
      id: DialogShowId.CUSTOM,
      size: DialogShowSize.MEDIUM,
      title: t(i18nKeys.FORM.ACTIONS),
      children: (
        <DebtorBatchActions
          debtorsSelected={listUserChecked}
          isSelectedAll={selectAll}
          totalObjects={totalObjects}
          reload={reload}
        />
      ),
    });
  };

  return <Button noMargin label={t(i18nKeys.FORM.ACTIONS)} onClick={openBatchActionsModal} />;
};
